import { useAuth } from "@/lib/auth";

export default function UserMenu() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="user-menu">
      {user.picture && (
        <img src={user.picture} alt="" referrerPolicy="no-referrer" />
      )}
      <span className="user-menu-name">{user.name}</span>
      {user.isAdmin && <span className="user-menu-admin-tag">Admin</span>}
      <button
        type="button"
        onClick={logout}
        className="user-menu-logout"
        aria-label="Log out"
        title="Log out"
      >
        ↪
      </button>
    </div>
  );
}
